import { useErrorHandling } from '@/composables/use-error-handling'
import { getApiErrorMessage } from '@/website/lib/api'
import type {
    LoginUserResponse,
    RegistrationVerificationResponse,
    UserTenants,
    VerifyOtpResponse,
} from '@/website/types'
import type { APIResponse } from '@/types/api'
import axios, { isAxiosError } from 'axios'
import endpoints from './endpoints'

export const usersApi = {
    // login: async (
    //     username: string,
    //     password: string,
    // ): Promise<[results?: LoginUserResponse | string, errorMessage?: string]> => {
    //     const request = axios.post<APIResponse<LoginUserResponse | string>>(
    //         `${endpoints.USERS_V1}/logins`,
    //         {
    //             username,
    //             password,
    //         },
    //     )

    //     try {
    //         const response = await useErrorHandling(request)
    //         return [response.data.data, undefined] as const
    //     } catch (error) {
    //         const errorMessage = getApiErrorMessage(error)
    //         if (isAxiosError(error) && error.response?.status === 403) {
    //             return [undefined, 'AUTH_FORBIDDEN']
    //         }
    //         return [undefined, errorMessage] as const
    //     }
    // },
    login: async (
        email: string,
        otp: string,
    ): Promise<[results?: LoginUserResponse | string, errorMessage?: string]> => {
        const request = axios.post<LoginUserResponse | string>(`${endpoints.USERS_V1}/logins`, {
            email,
            otp,
        })

        try {
            const response = await useErrorHandling(request)
            return [response.data, '']
        } catch (error) {
            const errorMessage = getApiErrorMessage(error)
            if (isAxiosError(error) && error.response?.status === 403) {
                return [undefined, 'AUTH_FORBIDDEN']
            }
            return [undefined, errorMessage]
        }
    },
    verifyRegistration: async (
        emailAddress: string,
        otp: string,
    ): Promise<[results?: RegistrationVerificationResponse, errorMessage?: string]> => {
        const request = axios.post<APIResponse<RegistrationVerificationResponse>>(
            `${endpoints.USERS_V1}/registrations/verifications`,
            {
                emailAddress,
                otp,
            },
        )

        try {
            const response = await useErrorHandling(request)
            return [response.data.data, '']
        } catch (error) {
            const errorMessage = getApiErrorMessage(error)

            return [undefined, errorMessage]
        }
    },
    requestOtp: async (
        userEmail: string,
    ): Promise<[results?: VerifyOtpResponse, errorMessage?: string]> => {
        const request = axios.post<VerifyOtpResponse>(`${endpoints.USERS_V1}/req-otp`, {
            userEmail,
        })

        try {
            const response = await useErrorHandling(request)
            return [response.data, '']
        } catch (error) {
            const errorMessage = getApiErrorMessage(error)
            if (isAxiosError(error) && error.response?.status === 403) {
                return [undefined, 'AUTH_FORBIDDEN']
            }
            return [undefined, errorMessage]
        }
    },
    getTenantsList: async (): Promise<[results?: UserTenants[], errorMessage?: string]> => {
        const request = axios.get<UserTenants[]>(`${endpoints.USERS_V1}/tenant-list`)

        try {
            const response = await useErrorHandling(request)
            return [response.data, '']
        } catch (error) {
            const errorMessage = getApiErrorMessage(error)

            return [undefined, errorMessage]
        }
    },
    getSubTenantsList: async (
        tenantKey: string,
    ): Promise<[results?: UserTenants[], errorMessage?: string]> => {
        const request = axios.get<UserTenants[]>(`${endpoints.USERS_V1}/tenant/sub-tenants`, {
            params: {
                tenantKey,
            },
        })

        try {
            const response = await useErrorHandling(request)
            return [response.data, '']
        } catch (error) {
            const errorMessage = getApiErrorMessage(error)

            return [undefined, errorMessage]
        }
    },
    assignTenant: async (
        userEmail: string,
        tenant: string,
        subTenant: string,
    ): Promise<[results?: VerifyOtpResponse, errorMessage?: string]> => {
        const request = axios.post<VerifyOtpResponse>(`${endpoints.USERS_V1}/assign-department`, {
            userEmail,
            tenant,
            subTenant,
        })

        try {
            const response = await useErrorHandling(request)
            return [response.data, '']
        } catch (error) {
            const errorMessage = getApiErrorMessage(error)

            return [undefined, errorMessage]
        }
    },
}
